import React, { useState, useEffect } from 'react';
import { projects as allProjects } from '../data';
import './Projects.css';

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const standardProjects = allProjects.filter(p => !p.tags?.includes('Research') && !p.title.includes('ECG'));
    setProjects(standardProjects);
  }, []);

  const getBadgeClass = (project) => {
    const text = (project.associatedWith || project.subtitle || '').toLowerCase();
    if (text.includes('government')) return 'pb-gov';
    if (text.includes('live') || text.includes('production')) return 'pb-live';
    if (text.includes('machine learning') || text.includes('deep learning') || text.includes('ml') || text.includes('neural')) return 'pb-research';
    if (text.includes('mobile') || text.includes('android')) return 'pb-mobile';
    return 'pb-build';
  };

  const getBadgeText = (project) => {
    const text = (project.associatedWith || project.subtitle || '').toLowerCase();
    if (text.includes('government')) return 'Government';
    if (text.includes('live') || text.includes('production')) return 'Live';
    if (text.includes('machine learning') || text.includes('deep learning') || text.includes('ml') || text.includes('neural')) return 'ML / AI';
    if (text.includes('mobile') || text.includes('android')) return 'Mobile';
    if (text.includes('academic')) return 'Academic';
    if (text.includes('enterprise')) return 'Enterprise';
    return 'Full Stack';
  };

  return (
    <section id="projects" className="sec">
      <div className="sec-inner">
        <div className="sec-label">04 — Projects</div>
        <h2 className="sec-title">Things I built that<br /><em>actually run</em></h2>

        <div className="proj-grid reveal">
          {projects.map((project, index) => (
            <div className="proj-card" data-index={String(index + 1).padStart(2, '0')} key={project._id || index}>
              {project.image && (
                <img src={project.image} alt={project.title} className="proj-img" />
              )}
              <div className={`proj-badge ${getBadgeClass(project)}`}>{getBadgeText(project)}</div>
              <div className="proj-name">{project.title}</div>
              <p className="proj-desc">{project.description}</p>
              <div className="proj-bottom">
                <div className="proj-tags">
                  {project.tags?.slice(0, 5).map((tag, tIndex) => (
                    <span className="ptag" key={tIndex}>{tag}</span>
                  ))}
                </div>
                <div className="proj-footer">
                  {project.liveLink ? (
                    <a href={project.liveLink} target="_blank" rel="noopener noreferrer" className="proj-link">
                      Live Site
                    </a>
                  ) : project.githubLink ? (
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="proj-link" aria-label={`GitHub — ${project.title}`}>
                      GitHub
                    </a>
                  ) : (
                    <span className="proj-link proj-link-disabled">Project</span>
                  )}
                  {project.liveLink && project.githubLink && (
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="proj-link proj-link-secondary" aria-label={`GitHub — ${project.title}`}>
                      GitHub
                    </a>
                  )}
                  <span className="proj-arrow">↗</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
